import React, {ReactNode, FC, memo} from 'react';
import * as antd from 'antd';
import * as antdLib from 'antd/lib/tabs';
import {Observer} from 'mobx-react-lite';

export interface TabPane extends antdLib.TabPaneProps {
    key: string;
    pane: ReactNode | (() => ReactNode);
}

interface TabsProps extends antdLib.TabsProps {
    tabs: TabPane[];
}

export const Tabs: FC<TabsProps> = memo(({tabs, ...rest}) => {
    return (
        <antd.Tabs
            defaultActiveKey={tabs[0].tabKey}
            items={tabs.map(({pane, key, tab: label}) => ({
                key,
                label,
                children: (
                    <Observer>
                        {() => {
                            return <>{typeof pane === 'function' ? pane() : pane}</>;
                        }}
                    </Observer>
                ),
            }))}
            {...rest}
        />
    );
});
